import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import ErrorScreen from './ErrorScreen';

const useStyles = makeStyles(() =>
  createStyles({
    icon: {
      color: 'var(--color-sub)',
      fontSize: 80
    }
  })
);

const ServerErrorScreen: React.FC<{}> = () => {
  const styles = useStyles({});

  return (
    <ErrorScreen
      visual={<ReportProblemOutlinedIcon className={styles.icon} />}
      title={'ページが表示できません'}
      description={
        <>
          サーバーエラーのため、しばらくたってから再度お試しください。
          <br />
          改善しない場合は、システム管理者にご確認ください。
        </>
      }
    />
  );
};

export default ServerErrorScreen;
